/**
 * ML impact API returns { aggregations: Record[] } — UI uses the first row for the current evidence set.
 */
export function selectFirstAggregationRow(
  data: { aggregations?: unknown[] } | null | undefined
): Record<string, unknown> | null {
  const row = data?.aggregations?.[0];
  if (row && typeof row === 'object') {
    return row as Record<string, unknown>;
  }
  return null;
}
